import {
  CreateShareFacebookShareChildAttachment,
  MutationUpdateShareArgs,
  Share,
  ShareSetting,
} from '@promoboxx/graphql-gateway-types'

import { ShareSettingDialogFormValues } from '@src/components/content/organicCampaignDetails/ShareSettingForm'

interface buildShareDialogPayloadProps {
  values: ShareSettingDialogFormValues
  shareSetting: ShareSetting
  share: Share
}

export const buildShareDialogPayload = (
  inputs: buildShareDialogPayloadProps,
) => {
  const { values, shareSetting, share } = inputs

  if (!share.share_setting_id) {
    return
  }

  const payload: MutationUpdateShareArgs = {
    id: share.id,
    shareType: shareSetting?.share_type || '',
  }

  if (shareSetting?.share_type === 'facebook') {
    payload.facebook_share = {
      retailer_url_override:
        shareSetting.child_attachments?.length ||
        !shareSetting.allow_retailer_url_override
          ? undefined
          : values.model.link,
      retailer_id: share.retailer_id || '',
      share_setting_id: share.share_setting_id,
      message: values.model.message,
      facebook_page_id: values.model.facebookPageId,
      scheduled_for: values.model.scheduled_for,
      customizations: share.customizations
        ? {
            child_attachments: shareSetting.child_attachments?.length
              ? values.model.child_attachments.map((childAttachment) => {
                  const ret: CreateShareFacebookShareChildAttachment = {
                    id: childAttachment.id,
                    description: childAttachment.description,
                    name: childAttachment.name,
                    retailer_url_override: childAttachment.link,
                  }

                  if (childAttachment.allow_retailer_url_override) {
                    ret.retailer_url_override = childAttachment.link
                  }

                  return ret
                })
              : undefined,
          }
        : undefined,
    }
  } else if (shareSetting?.share_type === 'instagram') {
    payload.instagram_share = {
      share_setting_id: share.share_setting_id,
      message: values.model.message,
      share_mode: 'manual',
      facebook_page_id: values.model.instagramPageId,
      scheduled_for: values.model.scheduled_for,
    }
  } else if (shareSetting?.share_type === 'twitter') {
    payload.twitter_share = {
      retailer_id: share.retailer_id || '',
      share_setting_id: share.share_setting_id,
      text: values.model.message,
      twitter_account_id: values.model.twitterAccountId,
      retailer_url_override: shareSetting.allow_retailer_url_override
        ? values.model.link
        : undefined,
      scheduled_for: values.model.scheduled_for,
    }
  } else if (shareSetting?.share_type === 'email') {
    payload.email_share = {
      subject: values.model.subject,
      text_body: share.html_body || '',
      html_body: share.html_body || '',
      scheduled_for: values.model.scheduled_for || undefined,
      selected_imports: values.model.selected_imports,
      share_setting_id: share.share_setting_id,
    }
    payload.fields = ['lead_imports']
  }

  return payload
}
